import type { App } from 'vue'

// 需要全局引入一些组件，如ElScrollbar，不然一些下拉项样式有问题
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'


export const setupElementPlus = (app: App<Element>) => {
  app.use(ElementPlus,{
    locale:zhCn
  })
  import('element-plus/dist/index.css')

}
